import React, { useState } from "react";
import clsx from "clsx";
import SingleSelect from "src/components/SingleSelect";
import apiService from "src/services/api.service";

const Revenue = (props) => {

    const [openSegment, setOpenSegment] = useState()
    const [selectedSegment, setSelectedSegment] = useState({
        id: props.calendar?.list_id?.segment === "Live" ? 1 : 2,
        name: props.calendar?.list_id?.segment
    })
    const [revenue, setRevenue] = useState(props.calendar.revenue)
    const [loading, setLoading] = useState(false)
    const [offerScore, setOfferScore] = useState()
    const segmentList = [{id: 1, name: "Live"}, {id: 2, name: "Repair"}]

    const selectSegment = (segment) => {
        setSelectedSegment(segment)
        setOpenSegment(false)
    }

    const handleRevenue = (value) => {
        setRevenue(value)
    }

    const handleUpdateRevenue = () => {
        apiService.updateRevenue({
            revenue: revenue,
            id: props.calendar?._id,
            segment: selectedSegment.name
        }).then(() => {
            props.setIsUpdate(true)
            props.close()
        })
    }

    const handleDisplayRevenue = () => {
        setLoading(true)
        apiService.calculateScore({id: props.calendar?._id, revenue: revenue}).then((response) => {
            setOfferScore(response.data?.score)
            setLoading(false)
        })
    }

    return (
        <div className="NewStrategyModalOverlay">
            <div className="RevenueModal">
                <div className={ "w-full flex justify-between" }>
                    <div className={ "DeleteStrategy" }>
                        <img alt={ "Logo" } src={ "/media/icons/warningRed.svg" } className={ "w-[18px] h-[18px]" }/>
                        Revenue input is required for this list.
                    </div>
                    <button className={ "CloseIconButton" } onClick={ props.close }>
                        <img alt={ "Logo" } src={ "/media/icons/closeIcon.svg" } className={ "w-5 h-5" }/>
                    </button>
                </div>
                <div className={ "RevenueHeaderNames" }>
                    <div className={ "RevenueListNameBox" }>
                        <img alt={ "Logo" }
                             src={ "/media/icons/rows.svg" }
                             className={ "w-[14px] h-[14px]" }/>
                        <div className={ "DashboardListNameTitle" }>List Name:</div>
                        <div className={ "SMSEmailBoxListName" }>{ props.calendar?.list_id?.name }</div>
                    </div>
                    <div className={ "HorizontalDivider" }></div>
                    <div className={ "RevenueListNameBox" }>
                        <img alt={ "Logo" }
                             src={ "/media/icons/offer.svg" }
                             className={ "w-[14px] h-[14px]" }/>
                        <div className={ "DashboardListNameTitle" }>Offer Name:</div>
                        <div className={ "SMSEmailBoxListName" }>{ props.calendar?.offer_id?.name }</div>
                    </div>
                    <div className={ "HorizontalDivider" }></div>
                    <div className={ "RevenueListNameBox" }>
                        <img alt={ "Logo" }
                             src={ "/media/icons/creative.svg" }
                             className={ "w-[14px] h-[14px]" }/>
                        <div className={ "DashboardListNameTitle" }>Creative Name:</div>
                        <div className={ "SMSEmailBoxListName" }>{ props.calendar?.creative_id?.name }</div>
                    </div>
                </div>
                <div className={ "HorizontalDivider" }></div>
                <div className={ "flex gap-[9px] w-full" }>
                    <div className={ "CalendarListDayContainer" }>
                        <div className={ "CalendarListDate" }>{ props.date.toLocaleString("default", {
                            month: "short",
                        }) } { props.day }</div>
                        <div
                            className={ "CalendarListDay" }>{ new Intl.DateTimeFormat("en-US", {weekday: "long"}).format(new Date(props.date?.getFullYear(), props.date?.getMonth(), props.day)) }</div>
                    </div>
                    <div className={ "w-full flex flex-col gap-6" }>
                        <div className={ "flex gap-4" }>
                            <div className={ "NewStrategyInputSection" }>
                                <div className={ "NewStrategyInputTitle" }>Segment</div>
                                { openSegment ?
                                    <SingleSelect setOpenSelect={ setOpenSegment } selectedItem={ selectedSegment }
                                                  selectItem={ selectSegment }
                                                  list={ segmentList }></SingleSelect> :
                                    <button className={ "TagSelect" }
                                            onClick={ () => setOpenSegment(true) }>{ selectedSegment ?
                                        <div className="flex gap-1 items-center text-black">
                                            <div
                                                className={ selectedSegment?.name === "Live" ? "ListSegmentLive" : "ListSegmentRepair" }></div>
                                            { selectedSegment?.name }
                                        </div>
                                        : "Select" }
                                        <img alt={ "Logo" } src={ "/media/icons/chevronDown.svg" }
                                             className={ "w-[18px] h-[18px]" }/>
                                    </button>
                                }
                            </div>
                            <div className={ clsx("NewStrategyInputSection") }>
                                <div className={ "NewStrategyInputTitle" }>Creative Name</div>
                                <input className={ "NewStrategyStrategyIdInput" } disabled
                                       value={ props.calendar?.creative_id?.name }/>
                            </div>
                        </div>
                        <div className={ "flex" }>
                            <div className={ "w-[530px]" }>
                                <div className={ "NewStrategyInputTitle" }>Revenue</div>
                                <div className={ "RevenueInputBox" }>
                                    <div className={ "flex gap-[6px] text-xs" }>
                                        <span className="input-prefix">$</span>
                                        <input className={ "RevenueInput" } type="number" value={ revenue }
                                               onChange={ (e) => handleRevenue(e.target.value) }/>
                                    </div>
                                    <button className={ "DisplayScoreButton" } disabled={ loading }
                                            onClick={ handleDisplayRevenue }>
                                        <img alt={ "Logo" }
                                             src={ loading ? "/media/icons/loading.svg" : "/media/icons/speedometer.svg" }
                                             className={ "h-3 w-3" }/>
                                        { loading ? "Loading..." : "Display Score" }
                                    </button>
                                </div>
                            </div>
                            { offerScore &&
                                <div className="relative">
                                    <div className="absolute left-full ml-2 flex flex-col items-center">
                                        <div
                                            className="p-3 w-[113px] flex flex-col justify-center items-center gap-2 bg-black text-white text-xs font-semibold rounded-md">
                                            Offer Score
                                            <div className={ "h-[1px] w-full bg-[#FFFFFF33]" }></div>
                                            <div className="text-[32px] font-medium m-1">
                                                { offerScore }
                                            </div>
                                            <div
                                                className="absolute left-[-7px] top-1/2 -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-r-8 border-r-black border-b-8 border-b-transparent"></div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={ "HorizontalDivider" }></div>
                <div className={ "modal-actions" }>
                    <button type="button" onClick={ props.close } className="CloseButton">
                        Close
                    </button>
                    <button type="submit" className="CreateButton" onClick={ handleUpdateRevenue }>
                        { "Save" }
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Revenue;